import * as FIELD_NAME from 'constant/form-item-names'
import * as FIELD_LABEL from 'constant/form-labels'
import * as NUMBER from 'constant/number'
import * as RULES from 'constant/form-rules'
import React from 'react'
import { Form, Input } from 'antd'
import styles from '../styles.scss'

const ShortDescriptionInput = () => {
  return (
    <>
      <span>{FIELD_LABEL.SHORT_DESCRIPTION_INPUT}</span>
      <Form.Item
        name={FIELD_NAME.SHORT_DESCRIPTION}
        rules={[RULES.maxCharLength(NUMBER.THREE_NINE_ZERO)]}
      >
        <Input.TextArea
          className={styles.form_textarea}
          placeholder={'Introduction'}
          rows={NUMBER.FOUR}
        />
      </Form.Item>
    </>
  )
}

export default ShortDescriptionInput
